import './header_contents.less';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import isNil from 'lodash/isNil';

import HeaderContentsUi from './header_contents.ui.jsx';

const HeaderContents = ({
  pageTitle,
  shouldShowTitle,
  secondaryLogoData,
  shouldShowLanguageSelectorInHeader,
  appliedLanguages,
  currentLanguageIso,
  defaultLanguageIso,
  onLanguageChange,
  onHeaderLogoClick
}) => {

  const {
    asset,
    url,
    backgroundSize,
    backgroundPosition
  } = secondaryLogoData;

  const secondaryLogoUrl = url;
  const hasSecondaryLogo = !!asset;
  const hasSecondaryLogoUrl = !isNil(url) && url !== '';

  const secondaryLogoStyle = (
    hasSecondaryLogo ?
    {
      backgroundSize,
      backgroundPosition,
      backgroundImage: `url(${asset.originalImage})`
    }
    :
      {}
  );

  const secondaryLogoClassName = classNames('header-thumbnail secondary-thumbnail', {
    'is-link': hasSecondaryLogoUrl 
  });

  const headerTitleStyle =  { display: shouldShowTitle ? null : 'none' };

  return (
    <HeaderContentsUi
      pageTitle={pageTitle}
      headerTitleStyle={headerTitleStyle}
      hasSecondaryLogo={hasSecondaryLogo}
      hasSecondaryLogoUrl={hasSecondaryLogoUrl}
      secondaryLogoUrl={secondaryLogoUrl}
      secondaryLogoStyle={secondaryLogoStyle}
      secondaryLogoClassName={secondaryLogoClassName}
      shouldShowLanguageSelectorInHeader={shouldShowLanguageSelectorInHeader}
      appliedLanguages={appliedLanguages}
      currentLanguageIso={currentLanguageIso}
      defaultLanguageIso={defaultLanguageIso}
      onLanguageChange={onLanguageChange}
      onHeaderLogoClick={onHeaderLogoClick}
    />
  );
};

HeaderContents.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  shouldShowTitle: PropTypes.bool.isRequired,
  onHeaderLogoClick: PropTypes.func.isRequired
};

export default HeaderContents;
